
import { mapGetters } from "vuex";
import Form from "./Form.vue";
import TerminalData from "./TerminalData";

export default {
  name: "app-terminal-create",
  data() {
    return {
      terminal: new TerminalData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
